import { Box, BoxProps, Button, Flex, Heading } from "@govlaunch/web";
import { useRouter } from "next/router";
import React from "react";
import useShowMoreCounter from "~/lib/hooks/useShowMoreCounter";
import ProjectsListing from "~/src/components/project/listing/ProjectsListing";
import { IProductBySlugQuery } from "~/src/components/product/graphql/__generated__/ProductBySlugQuery.generated";
import { FormattedMessage } from "react-intl";

interface IProductProjectsProps {
  product: NonNullable<IProductBySlugQuery["product"]>;
}

export default function ProductProjects({ product, ...props }: IProductProjectsProps & BoxProps) {
  const router = useRouter();
  const { offset, hasMore, showMore } = useShowMoreCounter(product.projects.length || 0, 2);
  const items = product.projects.slice(0, offset) || [];

  if (items.length === 0) {
    return null;
  }

  const onModalClose = () => {
    router.push(`/products/${product.slug}`);
  };

  return (
    <Box bg="white" borderRadius="md" border="1px" borderColor="gray.100" {...props}>
      <Box borderBottom="1px" borderColor="gray.100" py={3} px={8}>
        <Heading as="h3" color="gray.900" fontWeight="bold" fontSize="lg">
          <FormattedMessage defaultMessage="Projects" id="UxTJRa" />
        </Heading>
      </Box>

      <Box py={3} px={[4, 4, 4, 4]}>
        <ProjectsListing
          projects={items}
          onModalClose={onModalClose}
          gridProps={{
            columns: [1, 1, 1, 2],
            gridRowGap: 4,
          }}
        />

        {hasMore && (
          <Flex justify="center" mt={4}>
            <Button
              variant="secondary"
              size="sm"
              onClick={showMore}
              rightIcon={props => (
                <svg
                  width="24"
                  height="12"
                  viewBox="0 0 24 12"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  {...props}
                >
                  <path
                    d="M2 2.5L11.7436 9.55882L22 2.5"
                    stroke="currentColor"
                    strokeWidth="3"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              )}
            >
              <FormattedMessage defaultMessage="Show more" id="aWpBzj" />
            </Button>
          </Flex>
        )}
      </Box>
    </Box>
  );
}
